/**
 * BI EXPLORER MODULE
 * Pivot Table / Dynamic Analysis Tool
 * Allows users to explore financial data by dragging fields to rows/columns
 */

window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};
window.FazendaRP.Pages.Relatorios = window.FazendaRP.Pages.Relatorios || {};

window.FazendaRP.Pages.Relatorios.BIExplorer = {
    // State
    state: {
        activeSubTab: 'dashboard',  // 'dashboard', 'pivot', 'dre', 'fornecedores', 'safra'
        data: null,           // Raw data cache
        rowFields: [],        // Fields selected for rows
        colFields: [],        // Fields selected for columns
        valueField: 'valor',  // Field to aggregate
        aggregation: 'sum'    // sum, count, avg
    },

    // Available fields for drag and drop
    availableFields: [
        { id: 'safra', label: 'Safra', type: 'dimension' },
        { id: 'categoria', label: 'Categoria', type: 'dimension' },
        { id: 'parceiro', label: 'Parceiro', type: 'dimension' },
        { id: 'tipo', label: 'Tipo (Receita/Despesa)', type: 'dimension' },
        { id: 'mes', label: 'Mês', type: 'dimension' },
        { id: 'ano', label: 'Ano', type: 'dimension' },
        { id: 'conta', label: 'Conta Bancária', type: 'dimension' },
        { id: 'status', label: 'Status', type: 'dimension' }
    ],

    render: async function (container) {
        container.innerHTML = `
            <style>
                /* SUB-TABS */
                .bi-subtabs {
                    display: flex;
                    gap: 8px;
                    padding: 15px 20px 0 20px;
                    border-bottom: 2px solid #e5e7eb;
                    background: white;
                    margin-bottom: 0;
                }
                
                .bi-subtab-pill {
                    padding: 10px 20px;
                    background: transparent;
                    border: none;
                    border-bottom: 3px solid transparent;
                    cursor: pointer;
                    font-weight: 600;
                    font-size: 0.9rem;
                    color: #64748b;
                    transition: all 0.2s;
                    border-radius: 4px 4px 0 0;
                }
                
                .bi-subtab-pill:hover {
                    background: #f8fafc;
                    color: #3b82f6;
                }
                
                .bi-subtab-pill.active {
                    color: #3b82f6;
                    border-bottom-color: #3b82f6;
                    background: #eff6ff;
                }
                
                .bi-explorer-container { 
                    display: flex; 
                    height: calc(100% - 60px); 
                    gap: 20px; 
                    padding: 20px; 
                    background: #f8fafc; 
                }
                
                /* LEFT PANEL - Field List */
                .bi-field-panel {
                    width: 250px;
                    background: white;
                    border-radius: 8px;
                    padding: 16px;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                    overflow-y: auto;
                }
                
                .bi-field-panel h4 {
                    margin: 0 0 12px 0;
                    font-size: 0.85rem;
                    text-transform: uppercase;
                    color: #64748b;
                    font-weight: 600;
                }
                
                .bi-field-item {
                    padding: 10px 12px;
                    margin-bottom: 6px;
                    background: #f1f5f9;
                    border-radius: 6px;
                    cursor: grab;
                    font-size: 0.9rem;
                    color: #334155;
                    border: 2px solid transparent;
                    transition: all 0.2s;
                    user-select: none;
                }
                
                .bi-field-item:hover {
                    background: #e2e8f0;
                    border-color: #3b82f6;
                }
                
                .bi-field-item:active {
                    cursor: grabbing;
                }
                
                .bi-field-item.dragging {
                    opacity: 0.5;
                }
                
                /* RIGHT PANEL - Pivot Area */
                .bi-pivot-panel {
                    flex: 1;
                    background: white;
                    border-radius: 8px;
                    padding: 20px;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                    display: flex;
                    flex-direction: column;
                    gap: 15px;
                }
                
                .bi-drop-zone {
                    min-height: 50px;
                    padding: 12px;
                    border: 2px dashed #cbd5e1;
                    border-radius: 6px;
                    background: #f8fafc;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    flex-wrap: wrap;
                }
                
                .bi-drop-zone.drag-over {
                    border-color: #3b82f6;
                    background: #eff6ff;
                }
                
                .bi-drop-zone-label {
                    font-size: 0.8rem;
                    font-weight: 600;
                    color: #64748b;
                    text-transform: uppercase;
                    margin-bottom: 4px;
                }
                
                .bi-field-chip {
                    padding: 6px 12px;
                    background: #3b82f6;
                    color: white;
                    border-radius: 20px;
                    font-size: 0.85rem;
                    display: flex;
                    align-items: center;
                    gap: 6px;
                }
                
                .bi-field-chip .remove {
                    cursor: pointer;
                    font-weight: bold;
                    opacity: 0.8;
                }
                
                .bi-field-chip .remove:hover {
                    opacity: 1;
                }
                
                .bi-result-area {
                    flex: 1;
                    overflow: auto;
                    border: 1px solid #e5e7eb;
                    border-radius: 6px;
                    padding: 15px;
                    background: white;
                }
                
                .bi-result-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 0.9rem;
                }
                
                .bi-result-table th {
                    background: #f8fafc;
                    padding: 10px;
                    text-align: left;
                    font-weight: 600;
                    color: #475569;
                    border-bottom: 2px solid #e2e8f0;
                    position: sticky;
                    top: 0;
                }
                
                .bi-result-table td {
                    padding: 10px;
                    border-bottom: 1px solid #f1f5f9;
                }
                
                .bi-result-table tr:hover {
                    background: #f8fafc;
                }
                
                .bi-result-table td.value-cell {
                    text-align: right;
                    font-weight: 600;
                    color: #1e293b;
                }
                
                .bi-placeholder {
                    text-align: center;
                    padding: 60px 20px;
                    color: #94a3b8;
                }
                
                .bi-placeholder i {
                    font-size: 3rem;
                    margin-bottom: 15px;
                    opacity: 0.3;
                }
            </style>
            
            <!-- SUB-TABS PILLS -->
            <div class="bi-subtabs">
                <span class="bi-subtab-pill ${this.state.activeSubTab === 'dashboard' ? 'active' : ''}" onclick="window.FazendaRP.Pages.Relatorios.BIExplorer.switchSubTab('dashboard')">
                    <i class="fas fa-chart-pie"></i> Visão Geral
                </span>
                <span class="bi-subtab-pill ${this.state.activeSubTab === 'pivot' ? 'active' : ''}" onclick="window.FazendaRP.Pages.Relatorios.BIExplorer.switchSubTab('pivot')">
                    <i class="fas fa-table"></i> Pivot Livre
                </span>
                <span class="bi-subtab-pill ${this.state.activeSubTab === 'dre' ? 'active' : ''}" onclick="window.FazendaRP.Pages.Relatorios.BIExplorer.switchSubTab('dre')">
                    <i class="fas fa-chart-line"></i> DRE Interativo
                </span>
                <span class="bi-subtab-pill ${this.state.activeSubTab === 'fornecedores' ? 'active' : ''}" onclick="window.FazendaRP.Pages.Relatorios.BIExplorer.switchSubTab('fornecedores')">
                    <i class="fas fa-building"></i> Fornecedores
                </span>
                <span class="bi-subtab-pill ${this.state.activeSubTab === 'safra' ? 'active' : ''}" onclick="window.FazendaRP.Pages.Relatorios.BIExplorer.switchSubTab('safra')">
                    <i class="fas fa-seedling"></i> Por Safra
                </span>
            </div>
            
            <!-- CONTENT CONTAINER -->
            <div id="bi-subtab-content"></div>
        `;

        await this.loadData();
        this.switchSubTab('dashboard');
    },

    switchSubTab: function (subTabName) {
        this.state.activeSubTab = subTabName;

        // Update pills
        document.querySelectorAll('.bi-subtab-pill').forEach(btn => {
            const isActive = btn.textContent.trim().includes(
                subTabName === 'dashboard' ? 'Visão Geral' :
                    subTabName === 'pivot' ? 'Pivot Livre' :
                        subTabName === 'dre' ? 'DRE Interativo' :
                            subTabName === 'fornecedores' ? 'Fornecedores' :
                                'Por Safra'
            );
            btn.classList.toggle('active', isActive);
        });

        // Render content
        const contentArea = document.getElementById('bi-subtab-content');

        if (subTabName === 'dashboard') {
            this.renderDashboardView(contentArea);
        } else if (subTabName === 'pivot') {
            this.renderPivotView(contentArea);
        } else if (subTabName === 'dre') {
            this.renderDREView(contentArea);
        } else if (subTabName === 'fornecedores') {
            this.renderFornecedoresView(contentArea);
        } else if (subTabName === 'safra') {
            this.renderSafraView(contentArea);
        }
    },

    renderDashboardView: async function (container) {
        container.innerHTML = '<div style="text-align:center; padding:40px;"><i class="fas fa-spinner fa-spin fa-2x"></i><p>Carregando dashboard...</p></div>';
        await this.generateDashboardData();
    },

    generateDashboardData: async function () {
        try {
            const currentYear = new Date().getFullYear();
            const previousYear = currentYear - 1;

            // Fetch current year data
            const { data: currentData } = await window.FazendaRP.supabase
                .from('financeiro_lancamentos')
                .select('tipo, valor, data_emissao, detalhes')
                .neq('status', 'Cancelado')
                .gte('data_emissao', `${currentYear}-01-01`)
                .lte('data_emissao', `${currentYear}-12-31`);

            // Fetch previous year data for comparison
            const { data: previousData } = await window.FazendaRP.supabase
                .from('financeiro_lancamentos')
                .select('tipo, valor')
                .neq('status', 'Cancelado')
                .gte('data_emissao', `${previousYear}-01-01`)
                .lte('data_emissao', `${previousYear}-12-31`);

            // Calculate KPIs
            let totalReceita = 0;
            let totalCusto = 0;
            const monthlyData = {};

            currentData.forEach(l => {
                const valor = Math.abs(parseFloat(l.valor || 0));
                const month = l.data_emissao ? new Date(l.data_emissao).getMonth() : 0;

                if (!monthlyData[month]) {
                    monthlyData[month] = { receita: 0, custo: 0 };
                }

                if (l.tipo === 'Receita') {
                    totalReceita += valor;
                    monthlyData[month].receita += valor;
                } else {
                    totalCusto += valor;
                    monthlyData[month].custo += valor;
                }
            });

            // Previous year totals
            let prevReceita = 0;
            let prevCusto = 0;
            previousData.forEach(l => {
                const valor = Math.abs(parseFloat(l.valor || 0));
                if (l.tipo === 'Receita') prevReceita += valor;
                else prevCusto += valor;
            });

            const margem = totalReceita - totalCusto;
            const prevMargem = prevReceita - prevCusto;
            const roi = totalCusto > 0 ? (margem / totalCusto * 100) : 0;
            const prevRoi = prevCusto > 0 ? (prevMargem / prevCusto * 100) : 0;

            // Calculate trends
            const receitaTrend = prevReceita > 0 ? ((totalReceita - prevReceita) / prevReceita * 100) : 0;
            const custoTrend = prevCusto > 0 ? ((totalCusto - prevCusto) / prevCusto * 100) : 0;
            const margemTrend = prevMargem !== 0 ? ((margem - prevMargem) / Math.abs(prevMargem) * 100) : 0;
            const roiTrend = roi - prevRoi;

            // Render dashboard
            this.renderDashboard({
                receita: { value: totalReceita, trend: receitaTrend },
                custo: { value: totalCusto, trend: custoTrend },
                margem: { value: margem, trend: margemTrend },
                roi: { value: roi, trend: roiTrend },
                monthlyData: monthlyData
            });

        } catch (e) {
            console.error('Erro Dashboard:', e);
            document.getElementById('bi-subtab-content').innerHTML = `<div style="color:red; padding:20px;">Erro: ${e.message}</div>`;
        }
    },

    renderDashboard: function (data) {
        const container = document.getElementById('bi-subtab-content');
        const fmt = v => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        const trendIcon = t => t >= 0 ? 'fa-arrow-trend-up' : 'fa-arrow-trend-down';
        const trendColor = t => t >= 0 ? '#10b981' : '#ef4444';

        container.innerHTML = `
            <style>
                .dashboard-container {
                    padding: 20px;
                    background: #f8fafc;
                    min-height: 100%;
                }
                .dashboard-kpis {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
                    gap: 20px;
                    margin-bottom: 30px;
                }
                .kpi-card {
                    background: linear-gradient(135deg, var(--c1), var(--c2));
                    color: white;
                    padding: 25px;
                    border-radius: 12px;
                    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
                    position: relative;
                    overflow: hidden;
                }
                .kpi-card::before {
                    content: '';
                    position: absolute;
                    top: -50%;
                    right: -20px;
                    width: 150px;
                    height: 150px;
                    background: rgba(255,255,255,0.1);
                    border-radius: 50%;
                }
                .kpi-card h4 {
                    margin: 0 0 10px 0;
                    font-size: 0.85rem;
                    text-transform: uppercase;
                    opacity: 0.9;
                    font-weight: 600;
                }
                .kpi-card .value {
                    font-size: 2rem;
                    font-weight: 700;
                    margin: 5px 0;
                }
                .kpi-card .trend {
                    font-size: 0.9rem;
                    opacity: 0.95;
                }
                .dashboard-charts {
                    background: white;
                    padding: 20px;
                    border-radius: 12px;
                    margin-bottom: 20px;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                }
            </style>
            
            <div class="dashboard-container">
                <div class="dashboard-kpis">
                    <div class="kpi-card" style="--c1:#667eea; --c2:#764ba2;">
                        <h4><i class="fas fa-arrow-trend-up"></i> Receita Total</h4>
                        <div class="value">${fmt(data.receita.value)}</div>
                        <div class="trend"><i class="fas ${trendIcon(data.receita.trend)}"></i> ${data.receita.trend >= 0 ? '+' : ''}${data.receita.trend.toFixed(1)}% vs ano anterior</div>
                    </div>
                    
                    <div class="kpi-card" style="--c1:#f093fb; --c2:#f5576c;">
                        <h4><i class="fas fa-arrow-trend-down"></i> Custos Totais</h4>
                        <div class="value">${fmt(data.custo.value)}</div>
                        <div class="trend"><i class="fas ${trendIcon(data.custo.trend)}"></i> ${data.custo.trend >= 0 ? '+' : ''}${data.custo.trend.toFixed(1)}% vs ano anterior</div>
                    </div>
                    
                    <div class="kpi-card" style="--c1:#4facfe; --c2:#00f2fe;">
                        <h4><i class="fas fa-chart-line"></i> Margem Bruta</h4>
                        <div class="value" style="color:${data.margem.value >= 0 ? '#fff' : '#fee'}">${fmt(data.margem.value)}</div>
                        <div class="trend"><i class="fas ${trendIcon(data.margem.trend)}"></i> ${data.margem.trend >= 0 ? '+' : ''}${data.margem.trend.toFixed(1)}% vs ano anterior</div>
                    </div>
                    
                    <div class="kpi-card" style="--c1:#43e97b; --c2:#38f9d7;">
                        <h4><i class="fas fa-percentage"></i> ROI</h4>
                        <div class="value">${data.roi.value.toFixed(1)}%</div>
                        <div class="trend"><i class="fas ${trendIcon(data.roi.trend)}"></i> ${data.roi.trend >= 0 ? '+' : ''}${data.roi.trend.toFixed(1)}pp vs ano anterior</div>
                    </div>
                </div>
                
                <div class="dashboard-charts">
                    <h4 style="margin: 0 0 15px 0; color: #1e293b;"><i class="fas fa-chart-area"></i> Evolução Mensal</h4>
                    <canvas id="dashboard-trend-chart" width="800" height="300"></canvas>
                </div>
                
                <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 20px; margin-top: 20px;">
                    <!-- Alerts Widget -->
                    <div style="background: white; padding: 20px; border-radius: 12px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
                        <h4 style="margin: 0 0 15px 0; color: #1e293b;"><i class="fas fa-exclamation-triangle"></i> Alertas</h4>
                        <div id="dashboard-alerts"></div>
                    </div>
                    
                    <!-- Top 5 Suppliers Widget -->
                    <div style="background: white; padding: 20px; border-radius: 12px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
                        <h4 style="margin: 0 0 15px 0; color: #1e293b;"><i class="fas fa-building"></i> Top 5 Fornecedores</h4>
                        <div id="dashboard-suppliers"></div>
                    </div>
                    
                    <!-- Safra Summary Widget -->
                    <div style="background: white; padding: 20px; border-radius: 12px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
                        <h4 style="margin: 0 0 15px 0; color: #1e293b;"><i class="fas fa-seedling"></i> Performance da Safra Atual</h4>
                        <div id="dashboard-safra"></div>
                    </div>
                </div>
            </div>
        `;

        // Render trend chart
        this.renderDashboardTrendChart(data.monthlyData);

        // Render widgets
        this.renderDashboardAlerts(data);
        this.renderDashboardTopSuppliers();
        this.renderDashboardSafra();
    },

    renderDashboardTrendChart: function (monthlyData) {
        const canvas = document.getElementById('dashboard-trend-chart');
        if (!canvas) return;

        if (this.dashboardChart) {
            this.dashboardChart.destroy();
        }

        const ctx = canvas.getContext('2d');
        const monthNames = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

        const labels = monthNames;
        const receitaData = monthNames.map((_, i) => monthlyData[i]?.receita || 0);
        const custoData = monthNames.map((_, i) => monthlyData[i]?.custo || 0);

        this.dashboardChart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: labels,
                datasets: [
                    {
                        label: 'Receita',
                        data: receitaData,
                        borderColor: '#10b981',
                        backgroundColor: 'rgba(16, 185, 129, 0.1)',
                        borderWidth: 2,
                        fill: true,
                        tension: 0.4
                    },
                    {
                        label: 'Custos',
                        data: custoData,
                        borderColor: '#ef4444',
                        backgroundColor: 'rgba(239, 68, 68, 0.1)',
                        borderWidth: 2,
                        fill: true,
                        tension: 0.4
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: 'top',
                        labels: {
                            boxWidth: 15,
                            padding: 15,
                            font: { size: 12 }
                        }
                    },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                const label = context.dataset.label || '';
                                const value = context.parsed.y;
                                return `${label}: ${value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
                            }
                        }
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        ticks: {
                            callback: function (value) {
                                return 'R$ ' + (value / 1000).toFixed(0) + 'k';
                            }
                        }
                    }
                }
            }
        });
    },

    renderDashboardAlerts: function (data) {
        const alertsContainer = document.getElementById('dashboard-alerts');
        if (!alertsContainer) return;

        const alerts = [];

        // Check for negative margin
        if (data.margem.value < 0) {
            alerts.push({
                type: 'error',
                icon: 'fa-exclamation-circle',
                message: `Margem negativa de ${data.margem.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`
            });
        }

        // Check monthly negative margins
        const monthNames = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
        let negativeMonths = [];
        for (let month in data.monthlyData) {
            const m = data.monthlyData[month];
            if (m.receita - m.custo < 0) {
                negativeMonths.push(monthNames[month]);
            }
        }

        if (negativeMonths.length > 0) {
            alerts.push({
                type: 'warning',
                icon: 'fa-triangle-exclamation',
                message: `${negativeMonths.length} meses com margem negativa: ${negativeMonths.slice(0, 3).join(', ')}${negativeMonths.length > 3 ? '...' : ''}`
            });
        }

        // Check high costs
        const avgCusto = Object.values(data.monthlyData).reduce((sum, m) => sum + m.custo, 0) / Object.keys(data.monthlyData).length;
        let highCostMonths = [];
        for (let month in data.monthlyData) {
            if (data.monthlyData[month].custo > avgCusto * 1.2) {
                highCostMonths.push(monthNames[month]);
            }
        }

        if (highCostMonths.length > 0) {
            alerts.push({
                type: 'info',
                icon: 'fa-circle-info',
                message: `${highCostMonths.length} meses com custos 20% acima da média`
            });
        }

        if (alerts.length === 0) {
            alertsContainer.innerHTML = '<div style="text-align:center; padding:20px; color:#64748b;"><i class="fas fa-check-circle" style="font-size:2rem; color:#10b981;"></i><p style="margin-top:10px;">Tudo OK!</p></div>';
            return;
        }

        let html = '';
        alerts.forEach(alert => {
            const colors = {
                error: { bg: '#fee2e2', border: '#dc2626', text: '#991b1b' },
                warning: { bg: '#fef3c7', border: '#f59e0b', text: '#92400e' },
                info: { bg: '#dbeafe', border: '#3b82f6', text: '#1e40af' }
            };
            const c = colors[alert.type];

            html += `
                <div style="padding: 12px; margin-bottom: 10px; background: ${c.bg}; border-left: 4px solid ${c.border}; border-radius: 4px; font-size: 0.85rem;">
                    <i class="fas ${alert.icon}" style="color: ${c.border}; margin-right: 8px;"></i>
                    <span style="color: ${c.text};">${alert.message}</span>
                </div>
            `;
        });

        alertsContainer.innerHTML = html;
    },

    renderDashboardTopSuppliers: async function () {
        const suppliersContainer = document.getElementById('dashboard-suppliers');
        if (!suppliersContainer) return;

        suppliersContainer.innerHTML = '<div style="text-align:center; padding:10px;"><i class="fas fa-spinner fa-spin"></i> Carregando...</div>';

        try {
            const currentYear = new Date().getFullYear();

            const { data: lancamentos } = await window.FazendaRP.supabase
                .from('financeiro_lancamentos')
                .select('valor, parceiro_id, parceiros(nome)')
                .eq('tipo', 'Despesa')
                .neq('status', 'Cancelado')
                .gte('data_emissao', `${currentYear}-01-01`)
                .lte('data_emissao', `${currentYear}-12-31`);

            const supplierTotals = {};
            lancamentos.forEach(l => {
                if (l.parceiro_id && l.parceiros) {
                    const id = l.parceiro_id;
                    const nome = l.parceiros.nome || 'Sem Nome';
                    if (!supplierTotals[id]) {
                        supplierTotals[id] = { nome, total: 0 };
                    }
                    supplierTotals[id].total += Math.abs(parseFloat(l.valor || 0));
                }
            });

            const topSuppliers = Object.values(supplierTotals)
                .sort((a, b) => b.total - a.total)
                .slice(0, 5);

            if (topSuppliers.length === 0) {
                suppliersContainer.innerHTML = '<div style="text-align:center; padding:20px; color:#94a3b8;">Sem dados</div>';
                return;
            }

            const fmt = v => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

            let html = '<div style="font-size: 0.85rem;">';
            topSuppliers.forEach((s, i) => {
                const badge = i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : '';
                html += `
                    <div style="padding: 10px; border-bottom: 1px solid #f1f5f9; display: flex; justify-content: space-between; align-items: center;">
                        <div>
                            <span style="margin-right: 5px;">${badge}</span>
                            <strong>${s.nome}</strong>
                        </div>
                        <div style="color: #dc2626; font-family: 'Courier New', monospace; font-weight: 600;">
                            ${fmt(s.total)}
                        </div>
                    </div>
                `;
            });
            html += '</div>';
            html += `<div style="margin-top: 10px; text-align: center;"><button onclick="window.FazendaRP.Pages.Relatorios.BIExplorer.switchSubTab('fornecedores')" style="padding: 8px 16px; background: #3b82f6; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 0.85rem;"><i class="fas fa-arrow-right"></i> Ver Todos</button></div>`;

            suppliersContainer.innerHTML = html;

        } catch (e) {
            console.error('Erro ao carregar fornecedores:', e);
            suppliersContainer.innerHTML = '<div style="color:red; padding:10px; font-size: 0.85rem;">Erro ao carregar</div>';
        }
    },

    renderDashboardSafra: async function () {
        const safraContainer = document.getElementById('dashboard-safra');
        if (!safraContainer) return;

        safraContainer.innerHTML = '<div style="text-align:center; padding:10px;"><i class="fas fa-spinner fa-spin"></i> Carregando...</div>';

        try {
            // Get most recent safra
            const { data: safrasData } = await window.FazendaRP.supabase
                .from('safras_areas')
                .select('safra_id, area_ha')
                .order('safra_id', { ascending: false })
                .limit(100);

            if (!safrasData || safrasData.length === 0) {
                safraContainer.innerHTML = '<div style="text-align:center; padding:20px; color:#94a3b8;">Sem safra cadastrada</div>';
                return;
            }

            // Get most recent safra ID
            const currentSafraId = safrasData[0].safra_id;

            // Aggregate area
            let totalArea = 0;
            safrasData.forEach(s => {
                if (s.safra_id === currentSafraId) {
                    totalArea += parseFloat(s.area_ha || 0);
                }
            });

            // Get financial data for this safra
            const { data: lancamentos } = await window.FazendaRP.supabase
                .from('financeiro_lancamentos')
                .select('tipo, valor, detalhes')
                .neq('status', 'Cancelado');

            let receita = 0;
            let custo = 0;

            lancamentos.forEach(l => {
                const detalhes = typeof l.detalhes === 'string' ? JSON.parse(l.detalhes) : (l.detalhes || {});
                const rateios = detalhes.rateio || [];

                rateios.forEach(r => {
                    if (r.safra_id === currentSafraId) {
                        const valor = parseFloat(r.valor || 0);
                        if (l.tipo === 'Receita') receita += valor;
                        else custo += Math.abs(valor);
                    }
                });

                // Check per-item rateio
                const itens = detalhes.itens || [];
                itens.forEach(item => {
                    const itemRateios = item.rateio || [];
                    itemRateios.forEach(r => {
                        if (r.safra_id === currentSafraId) {
                            custo += Math.abs(parseFloat(r.valor || 0));
                        }
                    });
                });
            });

            const margem = receita - custo;
            const margemPct = receita > 0 ? (margem / receita * 100) : 0;
            const receitaHa = totalArea > 0 ? receita / totalArea : 0;
            const custoHa = totalArea > 0 ? custo / totalArea : 0;

            const fmt = v => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
            const margemColor = margem >= 0 ? '#10b981' : '#ef4444';

            let html = `
                <div style="font-size: 0.9rem;">
                    <div style="margin-bottom: 15px; padding-bottom: 15px; border-bottom: 2px solid #f1f5f9;">
                        <div style="font-size: 1.5rem; font-weight: 700; color: #1e293b;">Safra ${currentSafraId}</div>
                        <div style="color: #64748b; margin-top: 5px;">${totalArea.toFixed(2)} hectares</div>
                    </div>
                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; font-size: 0.85rem;">
                        <div>
                            <div style="color: #64748b;">Margem</div>
                            <div style="font-size: 1.2rem; font-weight: 700; color: ${margemColor};">${margemPct.toFixed(1)}%</div>
                        </div>
                        <div>
                            <div style="color: #64748b;">Receita/ha</div>
                            <div style="font-size: 1rem; font-weight: 600; color: #166534;">${fmt(receitaHa)}</div>
                        </div>
                        <div>
                            <div style="color: #64748b;">Custo/ha</div>
                            <div style="font-size: 1rem; font-weight: 600; color: #dc2626;">${fmt(custoHa)}</div>
                        </div>
                        <div>
                            <div style="color: #64748b;">Resultado</div>
                            <div style="font-size: 1rem; font-weight: 600; color: ${margemColor};">${fmt(margem)}</div>
                        </div>
                    </div>
                </div>
                <div style="margin-top: 15px; text-align: center;">
                    <button onclick="window.FazendaRP.Pages.Relatorios.BIExplorer.switchSubTab('safra')" style="padding: 8px 16px; background: #10b981; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 0.85rem;">
                        <i class="fas fa-seedling"></i> Ver Análise Completa
                    </button>
                </div>
            `;

            safraContainer.innerHTML = html;

        } catch (e) {
            console.error('Erro ao carregar safra:', e);
            safraContainer.innerHTML = '<div style="color:red; padding:10px; font-size: 0.85rem;">Erro ao carregar</div>';
        }
    },

    renderPivotView: function (container) {
        container.innerHTML = `
            <div class="bi-explorer-container">
                <!-- LEFT: Field List -->
                <div class="bi-field-panel">
                    <h4><i class="fas fa-database"></i> Campos Disponíveis</h4>
                    <div id="bi-field-list"></div>
                </div>
                
                <!-- RIGHT: Pivot Configuration + Results -->
                <div class="bi-pivot-panel">
                    <div>
                        <div class="bi-drop-zone-label">📊 Linhas (Arraste campos aqui)</div>
                        <div id="bi-drop-rows" class="bi-drop-zone" data-zone="rows">
                            <span style="color: #94a3b8; font-size: 0.85rem;">Nenhum campo selecionado</span>
                        </div>
                    </div>
                    
                    <div>
                        <div class="bi-drop-zone-label">📈 Colunas (Arraste campos aqui)</div>
                        <div id="bi-drop-cols" class="bi-drop-zone" data-zone="cols">
                            <span style="color: #94a3b8; font-size: 0.85rem;">Nenhum campo selecionado</span>
                        </div>
                    </div>
                    
                    <!-- QUICK TEMPLATES -->
                    <div style="margin-bottom: 15px; padding: 15px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); border-radius: 8px;">
                        <div style="color: white; font-size: 0.75rem; font-weight: 600; text-transform: uppercase; margin-bottom: 10px; opacity: 0.9;">⚡ Análises Rápidas</div>
                        <div style="display: flex; gap: 8px; flex-wrap: wrap;">
                            <button onclick="window.FazendaRP.Pages.Relatorios.BIExplorer.applyTemplate('dre')" style="padding: 6px 12px; background: rgba(255,255,255,0.2); border: 1px solid rgba(255,255,255,0.3); color: white; border-radius: 4px; font-size: 0.8rem; cursor: pointer; backdrop-filter: blur(10px);">
                                📊 DRE (Categoria×Mês)
                            </button>
                            <button onclick="window.FazendaRP.Pages.Relatorios.BIExplorer.applyTemplate('fornecedores')" style="padding: 6px 12px; background: rgba(255,255,255,0.2); border: 1px solid rgba(255,255,255,0.3); color: white; border-radius: 4px; font-size: 0.8rem; cursor: pointer; backdrop-filter: blur(10px);">
                                🏢 Top Fornecedores
                            </button>
                            <button onclick="window.FazendaRP.Pages.Relatorios.BIExplorer.applyTemplate('safra')" style="padding: 6px 12px; background: rgba(255,255,255,0.2); border: 1px solid rgba(255,255,255,0.3); color: white; border-radius: 4px; font-size: 0.8rem; cursor: pointer; backdrop-filter: blur(10px);">
                                🌾 Por Safra
                            </button>
                        </div>
                    </div>
                    
                    <div style="display: flex; gap: 10px; align-items: center;">
                        <label style="font-size: 0.85rem; font-weight: 600; color: #64748b;">Agregação:</label>
                        <select id="bi-agg-select" style="padding: 6px 10px; border: 1px solid #e5e7eb; border-radius: 4px;">
                            <option value="sum">Soma</option>
                            <option value="count">Contagem</option>
                            <option value="avg">Média</option>
                        </select>
                        <button id="bi-refresh-btn" class="btn btn-primary" style="padding: 6px 16px;">
                            <i class="fas fa-sync-alt"></i> Atualizar
                        </button>
                    </div>
                    
                    <div class="bi-result-area" id="bi-result-area">
                        <div class="bi-placeholder">
                            <i class="fas fa-table"></i>
                            <p>Arraste campos para <b>Linhas</b> e <b>Colunas</b> para começar a explorar os dados.</p>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        `;

        this.initDragDrop();
        this.initEvents();
    },

    renderDREView: async function (container) {
        const currentYear = new Date().getFullYear();

        container.innerHTML = `
            <style>
                .dre-container {
                    padding: 20px;
                    background: white;
                    height: 100%;
                    overflow: auto;
                }
                
                .dre-controls {
                    display: flex;
                    gap: 15px;
                    margin-bottom: 20px;
                    align-items: center;
                    padding-bottom: 15px;
                    border-bottom: 2px solid #e5e7eb;
                }
                
                .dre-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 0.9rem;
                }
                
                .dre-table th {
                    background: #f8fafc;
                    padding: 12px;
                    text-align: left;
                    font-weight: 600;
                    color: #475569;
                    border-bottom: 2px solid #e2e8f0;
                    position: sticky;
                    top: 0;
                    z-index: 10;
                }
                
                .dre-table td {
                    padding: 10px 12px;
                    border-bottom: 1px solid #f1f5f9;
                }
                
                .dre-table tr:hover {
                    background: #f8fafc;
                }
                
                .dre-row-group-header {
                    background: #eef2ff;
                    font-weight: 700;
                    color: #334155;
                    cursor: pointer;
                }
                
                .dre-row-group-header td:first-child {
                    text-align: left;
                }
                
                .dre-row-group-header:hover {
                    background: #e0e7ff;
                }
                
                .dre-row-group-header i {
                    margin-right: 8px;
                    transition: transform 0.2s;
                }
                
                .dre-row-group-header.collapsed i {
                    transform: rotate(-90deg);
                }
                
                .dre-row-account {
                    font-size: 0.85rem;
                }
                
                .dre-row-total {
                    background: #f1f5f9;
                    font-weight: 700;
                    border-top: 2px solid #cbd5e1;
                }
                
                .dre-row-resultado {
                    background: #e0e7ff;
                    font-weight: 800;
                    font-size: 1rem;
                    border-top: 3px solid #6366f1;
                    color: #312e81;
                }
                
                .dre-value-cell {
                    text-align: right;
                    font-family: 'Courier New', monospace;
                }
                
                .value-positive { color: #166534; }
                .value-negative { color: #dc2626; }
                
                /* Force first column to be left-aligned */
                .dre-table td:first-child,
                .dre-table th:first-child {
                    text-align: left !important;
                }
            </style>
            
            <div class="dre-container">
                <div class="dre-controls">
                    <label style="font-size: 0.9rem; font-weight: 600; color: #64748b;">Ano:</label>
                    <select id="dre-year-select" style="padding: 8px; border: 1px solid #e5e7eb; border-radius: 4px;">
                        <option value="${currentYear}" selected>${currentYear}</option>
                        <option value="${currentYear - 1}">${currentYear - 1}</option>
                        <option value="${currentYear - 2}">${currentYear - 2}</option>
                    </select>
                    <button onclick="window.FazendaRP.Pages.Relatorios.BIExplorer.generateDRE()" class="btn btn-primary" style="padding: 8px 16px;">
                        <i class="fas fa-sync-alt"></i> Gerar DRE
                    </button>
                </div>
                <div id="dre-table-container">
                    <div style="text-align:center; padding:60px; color:#94a3b8;">
                        <i class="fas fa-chart-line fa-3x"></i>
                        <p style="margin-top:15px;">Clique em <b>"Gerar DRE"</b> para visualizar o relatório</p>
                    </div>
                </div>
            </div>
        `;
    },

    generateDRE: async function () {
        const yearSelect = document.getElementById('dre-year-select');
        if (!yearSelect) return;

        const year = parseInt(yearSelect.value);
        const container = document.getElementById('dre-table-container');

        container.innerHTML = '<div style="text-align:center; padding:40px;"><i class="fas fa-spinner fa-spin fa-2x"></i><p>Processando lançamentos...</p></div>';

        // Initialize collapsed state if not exists
        if (!this.state.dreCollapsed) {
            this.state.dreCollapsed = {};
        }

        try {
            // Fetch data
            const { data: planoContas } = await window.FazendaRP.supabase
                .from('financeiro_plano_contas')
                .select('*')
                .order('codigo');

            const { data: lancs } = await window.FazendaRP.supabase
                .from('financeiro_lancamentos')
                .select('*, parceiros(nome)')
                .neq('status', 'Cancelado')
                .gte('data_emissao', `${year}-01-01`)
                .lte('data_emissao', `${year}-12-31`);

            // Setup account map
            const contaMap = {};
            planoContas.forEach(c => {
                if (c.codigo) contaMap[c.codigo] = { ...c, valor: 0, itens: [] };
            });

            // Process transactions
            lancs.forEach(l => {
                const catKey = String(l.categoria || '').split(' - ')[0].trim();
                let conta = contaMap[catKey];

                if (!conta) {
                    const m = planoContas.find(c => c.id == catKey || c.nome == catKey);
                    if (m) conta = contaMap[m.codigo];
                }

                if (conta) {
                    let valor = parseFloat(l.valor || 0);

                    // Force signs based on type
                    if (l.tipo && l.tipo.toLowerCase().includes('despesa')) {
                        valor = -Math.abs(valor);
                    } else {
                        valor = Math.abs(valor);
                    }

                    conta.valor += valor;
                    conta.itens.push(l); // Store transaction item

                    // Aggregate to parents
                    let parts = conta.codigo.split('.');
                    while (parts.length > 1) {
                        parts.pop();
                        let pai = contaMap[parts.join('.')];
                        if (pai) pai.valor += valor;
                    }
                }
            });

            // Group accounts
            const grupos = {
                receitas: [],
                custos: [],
                despesasOp: [],
                recNaoOp: [],
                despNaoOp: [],
                despFin: []
            };

            Object.values(contaMap).forEach(c => {
                if (!c.codigo || ['1', '2', '3'].includes(c.codigo)) return;

                // Filter out parent accounts - only show leaf accounts
                const isParent = Object.keys(contaMap).some(k => k.startsWith(c.codigo + '.'));
                if (isParent) return;

                if (c.codigo.startsWith('1')) grupos.receitas.push(c);
                else if (c.codigo.startsWith('2.1')) grupos.custos.push(c);
                else if (c.codigo.startsWith('2.2')) grupos.despesasOp.push(c);
                else if (c.codigo.startsWith('3')) grupos.recNaoOp.push(c);
                else if (c.codigo.startsWith('2.3')) grupos.despNaoOp.push(c);
                else if (c.codigo.startsWith('2.4')) grupos.despFin.push(c);
            });

            // Calculate totals
            const sum = list => list.reduce((s, c) => s + c.valor, 0);
            const totReceita = sum(grupos.receitas);
            const totCustos = sum(grupos.custos);
            const totDespOp = sum(grupos.despesasOp);
            const totLucroBruto = totReceita + totCustos;
            const totEBIT = totLucroBruto + totDespOp;
            const totRecNaoOp = sum(grupos.recNaoOp);
            const totDespNaoOp = sum(grupos.despNaoOp);
            const totDespFin = sum(grupos.despFin);
            const totFinal = totEBIT + totRecNaoOp + totDespNaoOp + totDespFin;

            // Formatters
            const fmt = v => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
            const valClass = v => v >= 0 ? 'value-positive' : 'value-negative';

            // Render
            let html = `
                <table class="dre-table">
                    <thead>
                        <tr>
                            <th style="text-align: left;">CONTA</th>
                            <th style="text-align: right; width: 150px;">VALOR (${year})</th>
                        </tr>
                    </thead>
                    <tbody>
            `;

            const renderGroup = (label, list, groupId) => {
                if (!list || list.length === 0) return;

                const total = sum(list);
                const collapsed = this.state.dreCollapsed[groupId];

                html += `
                    <tr class="dre-row-group-header ${collapsed ? 'collapsed' : ''}" onclick="window.FazendaRP.Pages.Relatorios.BIExplorer.toggleDREGroup('${groupId}')">
                        <td><i class="fas fa-chevron-down"></i> ${label}</td>
                        <td class="dre-value-cell ${valClass(total)}">${fmt(total)}</td>
                    </tr>
                `;

                if (!collapsed) {
                    list.forEach(c => {
                        if (Math.abs(c.valor) < 0.01) return;
                        const level = c.codigo.split('.').length;
                        const indent = level * 20;

                        // Escape quotes for onclick
                        const codigo = c.codigo.replace(/'/g, "\\'");
                        const nome = c.nome.replace(/'/g, "\\'");

                        html += `
                            <tr class="dre-row-account group-${groupId}">
                                <td style="padding-left: ${indent}px;">${c.codigo} - ${c.nome}</td>
                                <td class="dre-value-cell ${valClass(c.valor)}" 
                                    onclick="window.FazendaRP.Pages.Relatorios.BIExplorer.showDREDrillDown('${codigo}', '${nome}', ${c.itens.length})" 
                                    style="cursor: pointer;"
                                    title="Clique para ver detalhes">
                                    ${fmt(c.valor)}
                                </td>
                            </tr>
                        `;
                    });
                }
            };

            renderGroup('RECEITAS BRUTAS', grupos.receitas, 'receitas');
            html += `<tr class="dre-row-total"><td>(=) RECEITA BRUTA</td><td class="dre-value-cell ${valClass(totReceita)}">${fmt(totReceita)}</td></tr>`;

            renderGroup('(-) CUSTOS DE PRODUÇÃO', grupos.custos, 'custos');
            html += `<tr class="dre-row-total"><td>(=) LUCRO BRUTO</td><td class="dre-value-cell ${valClass(totLucroBruto)}">${fmt(totLucroBruto)}</td></tr>`;

            renderGroup('(-) DESPESAS OPERACIONAIS', grupos.despesasOp, 'despop');
            html += `<tr class="dre-row-resultado"><td>(=) RESULTADO OPERACIONAL (EBIT)</td><td class="dre-value-cell ${valClass(totEBIT)}">${fmt(totEBIT)}</td></tr>`;

            renderGroup('(+) OUTRAS RECEITAS', grupos.recNaoOp, 'recnaoop');
            renderGroup('(-) OUTRAS DESPESAS', grupos.despNaoOp, 'despnaoop');
            renderGroup('(-) DESPESAS FINANCEIRAS', grupos.despFin, 'despfin');

            html += `<tr class="dre-row-resultado"><td>(=) RESULTADO LÍQUIDO</td><td class="dre-value-cell ${valClass(totFinal)}">${fmt(totFinal)}</td></tr>`;

            html += '</tbody></table>';

            // Store contaMap for drill-down
            this.state.dreContaMap = contaMap;

            container.innerHTML = html;

        } catch (e) {
            console.error('Erro DRE:', e);
            container.innerHTML = `<div style="color:red; padding:20px;">Erro: ${e.message}</div>`;
        }
    },

    toggleDREGroup: function (groupId) {
        this.state.dreCollapsed[groupId] = !this.state.dreCollapsed[groupId];
        this.generateDRE();
    },

    showDREDrillDown: function (contaCodigo, contaNome, numItens) {
        if (numItens === 0) {
            alert('Não há itens para exibir');
            return;
        }

        const conta = this.state.dreContaMap?.[contaCodigo];
        if (!conta || !conta.itens || conta.itens.length === 0) {
            alert('Dados não encontrados');
            return;
        }

        // Create modal overlay
        const modalHTML = `
            <div id="dre-drilldown-modal" style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); z-index: 9999; display: flex; align-items: center; justify-content: center;" onclick="document.getElementById('dre-drilldown-modal').remove()">
                <div style="background: white; border-radius: 8px; padding: 20px; max-width: 90%; max-height: 90%; overflow: auto; box-shadow: 0 4px 6px rgba(0,0,0,0.1);" onclick="event.stopPropagation()">
                    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; border-bottom: 2px solid #e5e7eb; padding-bottom: 15px;">
                        <h3 style="margin: 0; color: #1e293b;">${contaCodigo} - ${contaNome}</h3>
                        <button onclick="document.getElementById('dre-drilldown-modal').remove()" style="background: #ef4444; color: white; border: none; padding: 8px 16px; border-radius: 4px; cursor: pointer; font-weight: 600;">
                            <i class="fas fa-times"></i> Fechar
                        </button>
                    </div>
                    <table style="width: 100%; border-collapse: collapse; font-size: 0.85rem;">
                        <thead>
                            <tr style="background: #f8fafc; border-bottom: 2px solid #e2e8f0;">
                                <th style="padding: 10px; text-align: left;">Data</th>
                                <th style="padding: 10px; text-align: left;">Nº Doc</th>
                                <th style="padding: 10px; text-align: left;">Descrição</th>
                                <th style="padding: 10px; text-align: left;">Produtos/Itens</th>
                                <th style="padding: 10px; text-align: left;">Parceiro</th>
                                <th style="padding: 10px; text-align: right;">Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${conta.itens.map(item => {
            const valor = parseFloat(item.valor || 0);
            const valorClass = valor >= 0 ? 'color: #166534' : 'color: #dc2626';
            const dataFormatada = new Date(item.data_emissao).toLocaleDateString('pt-BR');

            // Extract products from detalhes
            let produtos = '-';
            try {
                const detalhes = typeof item.detalhes === 'string' ? JSON.parse(item.detalhes) : item.detalhes;
                if (detalhes?.itens && Array.isArray(detalhes.itens) && detalhes.itens.length > 0) {
                    produtos = detalhes.itens
                        .map(i => {
                            const nome = i.item_nome || i.nome || '-';
                            const qtd = i.quantidade ? ` (${i.quantidade})` : '';
                            return nome + qtd;
                        })
                        .join(', ');

                    // Limit length
                    if (produtos.length > 80) {
                        produtos = produtos.substring(0, 77) + '...';
                    }
                }
            } catch (e) {
                // Keep default '-'
            }

            return `
                                    <tr style="border-bottom: 1px solid #f1f5f9;">
                                        <td style="padding: 10px;">${dataFormatada}</td>
                                        <td style="padding: 10px;">${item.num_doc || '-'}</td>
                                        <td style="padding: 10px;">${item.descricao || '-'}</td>
                                        <td style="padding: 10px; font-size: 0.8rem; color: #64748b;" title="${produtos}">${produtos}</td>
                                        <td style="padding: 10px;">${item.parceiros?.nome || '-'}</td>
                                        <td style="padding: 10px; text-align: right; font-family: 'Courier New', monospace; font-weight: 600; ${valorClass}">
                                            ${valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                        </td>
                                    </tr>
                                `;
        }).join('')}
                        </tbody>
                        <tfoot>
                            <tr style="background: #f1f5f9; font-weight: 700; border-top: 2px solid #cbd5e1;">
                                <td colspan="5" style="padding: 12px; text-align: right;">TOTAL:</td>
                                <td style="padding: 12px; text-align: right; font-family: 'Courier New', monospace;">
                                    ${conta.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        `;

        document.body.insertAdjacentHTML('beforeend', modalHTML);
    },

    renderFornecedoresView: async function (container) {
        const currentYear = new Date().getFullYear();

        container.innerHTML = `
            <style>
                .supplier-container {
                    padding: 20px;
                    background: white;
                    height: 100%;
                    overflow: auto;
                }
                
                .supplier-controls {
                    display: flex;
                    gap: 15px;
                    margin-bottom: 20px;
                    align-items: center;
                    padding-bottom: 15px;
                    border-bottom: 2px solid #e5e7eb;
                }
                
                .supplier-stats {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                    gap: 15px;
                    margin-bottom: 20px;
                }
                
                .stat-card {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    color: white;
                    padding: 20px;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                }
                
                .stat-card h4 {
                    margin: 0 0 5px 0;
                    font-size: 0.75rem;
                    text-transform: uppercase;
                    opacity: 0.9;
                }
                
                .stat-card .value {
                    font-size: 1.5rem;
                    font-weight: 700;
                    margin: 0;
                }
                
                .supplier-content {
                    display: grid;
                    grid-template-columns: 1fr 400px;
                    gap: 20px;
                }
                
                .supplier-table-container {
                    background: white;
                    border-radius: 8px;
                    overflow: auto;
                    max-height: 600px;
                }
                
                .supplier-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 0.9rem;
                }
                
                .supplier-table th {
                    background: #f8fafc;
                    padding: 12px;
                    text-align: left;
                    font-weight: 600;
                    color: #475569;
                    border-bottom: 2px solid #e2e8f0;
                    position: sticky;
                    top: 0;
                    z-index: 10;
                }
                
                .supplier-table td {
                    padding: 10px 12px;
                    border-bottom: 1px solid #f1f5f9;
                }
                
                .supplier-table tr:hover {
                    background: #f8fafc;
                }
                
                .supplier-chart-container {
                    background: white;
                    border-radius: 8px;
                    padding: 20px;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                }
                
                .rank-badge {
                    display: inline-block;
                    width: 30px;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                    border-radius: 50%;
                    font-weight: 700;
                    font-size: 0.85rem;
                }
                
                .rank-1 { background: #fbbf24; color: white; }
                .rank-2 { background: #94a3b8; color: white; }
                .rank-3 { background: #cd7f32; color: white; }
                .rank-other { background: #e5e7eb; color: #64748b; }
            </style>
            
            <div class="supplier-container">
                <div class="supplier-controls">
                    <label style="font-size: 0.9rem; font-weight: 600; color: #64748b;">Período:</label>
                    <select id="supplier-year-select" style="padding: 8px; border: 1px solid #e5e7eb; border-radius: 4px;">
                        <option value="${currentYear}">2026</option>
                        <option value="${currentYear - 1}" selected>2025</option>
                        <option value="${currentYear - 2}">2024</option>
                        <option value="all">Todos os Anos</option>
                    </select>
                    <button onclick="window.FazendaRP.Pages.Relatorios.BIExplorer.generateSupplierAnalysis()" class="btn btn-primary" style="padding: 8px 16px;">
                        <i class="fas fa-sync-alt"></i> Gerar Análise
                    </button>
                </div>
                
                <div id="supplier-stats-area"></div>
                
                <div class="supplier-content">
                    <div class="supplier-table-container">
                        <div id="supplier-table-area" style="text-align:center; padding:60px; color:#94a3b8;">
                            <i class="fas fa-building fa-3x"></i>
                            <p style="margin-top:15px;">Clique em <b>"Gerar Análise"</b> para visualizar o ranking</p>
                        </div>
                    </div>
                    
                    <div class="supplier-chart-container">
                        <h4 style="margin: 0 0 15px 0; color: #1e293b;">Top 10 Fornecedores</h4>
                        <canvas id="supplier-chart" width="350" height="350"></canvas>
                    </div>
                </div>
            </div>
        `;
    },

    generateSupplierAnalysis: async function () {
        const yearSelect = document.getElementById('supplier-year-select');
        if (!yearSelect) return;

        const selectedPeriod = yearSelect.value;
        const statsArea = document.getElementById('supplier-stats-area');
        const tableArea = document.getElementById('supplier-table-area');

        tableArea.innerHTML = '<div style="text-align:center; padding:40px;"><i class="fas fa-spinner fa-spin fa-2x"></i><p>Processando gastos...</p></div>';

        try {
            // Fetch data
            let query = window.FazendaRP.supabase
                .from('financeiro_lancamentos')
                .select('*, parceiros(nome)')
                .neq('status', 'Cancelado')
                .eq('tipo', 'Despesa');

            if (selectedPeriod !== 'all') {
                const year = parseInt(selectedPeriod);
                query = query
                    .gte('data_emissao', `${year}-01-01`)
                    .lte('data_emissao', `${year}-12-31`);
            }

            const { data: lancamentos } = await query;

            // Aggregate by supplier
            const supplierMap = {};
            let totalGasto = 0;

            lancamentos.forEach(l => {
                const supplier = l.parceiros?.nome || 'Sem Parceiro';
                const valor = Math.abs(parseFloat(l.valor || 0));

                if (!supplierMap[supplier]) {
                    supplierMap[supplier] = {
                        nome: supplier,
                        total: 0,
                        count: 0
                    };
                }

                supplierMap[supplier].total += valor;
                supplierMap[supplier].count++;
                totalGasto += valor;
            });

            // Sort by total descending
            const suppliers = Object.values(supplierMap).sort((a, b) => b.total - a.total);

            // Stats cards
            const top3Total = suppliers.slice(0, 3).reduce((sum, s) => sum + s.total, 0);
            const top3Percent = totalGasto > 0 ? (top3Total / totalGasto * 100).toFixed(1) : 0;

            statsArea.innerHTML = `
                <div class="supplier-stats">
                    <div class="stat-card" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
                        <h4>Total Gasto</h4>
                        <p class="value">${totalGasto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                    </div>
                    <div class="stat-card" style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);">
                        <h4>Fornecedores Ativos</h4>
                        <p class="value">${suppliers.length}</p>
                    </div>
                    <div class="stat-card" style="background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);">
                        <h4>Top 3 Representam</h4>
                        <p class="value">${top3Percent}%</p>
                    </div>
                    <div class="stat-card" style="background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);">
                        <h4>Ticket Médio</h4>
                        <p class="value">${(totalGasto / lancamentos.length).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                    </div>
                </div>
            `;

            // Render table
            const fmt = v => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
            const pct = (v, total) => total > 0 ? ((v / total) * 100).toFixed(1) + '%' : '0%';

            let tableHTML = `
                <table class="supplier-table">
                    <thead>
                        <tr>
                            <th style="width: 60px;">#</th>
                            <th>Fornecedor</th>
                            <th style="text-align: center;">Nº Notas</th>
                            <th style="text-align: right;">Total Gasto</th>
                            <th style="text-align: right;">% do Total</th>
                        </tr>
                    </thead>
                    <tbody>
            `;

            suppliers.forEach((s, idx) => {
                const rank = idx + 1;
                const rankClass = rank === 1 ? 'rank-1' : rank === 2 ? 'rank-2' : rank === 3 ? 'rank-3' : 'rank-other';

                tableHTML += `
                    <tr>
                        <td><span class="rank-badge ${rankClass}">${rank}</span></td>
                        <td><strong>${s.nome}</strong></td>
                        <td style="text-align: center;">${s.count}</td>
                        <td style="text-align: right; font-family: 'Courier New', monospace; font-weight: 600; color: #dc2626;">
                            ${fmt(s.total)}
                        </td>
                        <td style="text-align: right; color: #64748b;">${pct(s.total, totalGasto)}</td>
                    </tr>
                `;
            });

            tableHTML += '</tbody></table>';
            tableArea.innerHTML = tableHTML;

            // Render chart (top 10)
            this.renderSupplierChart(suppliers.slice(0, 10));

        } catch (e) {
            console.error('Erro Supplier Analysis:', e);
            tableArea.innerHTML = `<div style="color:red; padding:20px;">Erro: ${e.message}</div>`;
        }
    },

    renderSupplierChart: function (topSuppliers) {
        const canvas = document.getElementById('supplier-chart');
        if (!canvas) return;

        // Destroy previous chart if exists
        if (this.supplierChart) {
            this.supplierChart.destroy();
        }

        const ctx = canvas.getContext('2d');

        // Chart.js colors
        const colors = [
            '#667eea', '#764ba2', '#f093fb', '#f5576c', '#4facfe',
            '#00f2fe', '#43e97b', '#38f9d7', '#fa709a', '#fee140'
        ];

        // Store supplier data for drill-down
        this.supplierChartData = topSuppliers;

        this.supplierChart = new Chart(ctx, {
            type: 'pie',
            data: {
                labels: topSuppliers.map(s => s.nome),
                datasets: [{
                    data: topSuppliers.map(s => s.total),
                    backgroundColor: colors,
                    borderWidth: 2,
                    borderColor: '#fff'
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                onClick: (event, elements) => {
                    if (elements.length > 0) {
                        const index = elements[0].index;
                        const supplierName = topSuppliers[index].nome;
                        this.showSupplierProductBreakdown(supplierName);
                    }
                },
                plugins: {
                    legend: {
                        position: 'bottom',
                        labels: {
                            boxWidth: 15,
                            padding: 10,
                            font: { size: 11 }
                        }
                    },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                const value = context.parsed;
                                const total = context.dataset.data.reduce((a, b) => a + b, 0);
                                const pct = ((value / total) * 100).toFixed(1);
                                return `${context.label}: ${value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} (${pct}%) - Clique para detalhes`;
                            }
                        }
                    }
                }
            }
        });
    },

    showSupplierProductBreakdown: async function (supplierName) {
        try {
            // Fetch all purchases from this supplier
            const yearSelect = document.getElementById('supplier-year-select');
            const selectedPeriod = yearSelect ? yearSelect.value : 'all';

            let query = window.FazendaRP.supabase
                .from('financeiro_lancamentos')
                .select('*, parceiros(nome)')
                .neq('status', 'Cancelado')
                .eq('tipo', 'Despesa');

            if (selectedPeriod !== 'all') {
                const year = parseInt(selectedPeriod);
                query = query
                    .gte('data_emissao', `${year}-01-01`)
                    .lte('data_emissao', `${year}-12-31`);
            }

            const { data: allLancamentos } = await query;

            // Filter by supplier
            const supplierLancamentos = allLancamentos.filter(l =>
                (l.parceiros?.nome || 'Sem Parceiro') === supplierName
            );

            // Extract products from detalhes
            const produtoMap = {};
            let totalSupplier = 0;

            supplierLancamentos.forEach(l => {
                const valor = Math.abs(parseFloat(l.valor || 0));
                totalSupplier += valor;

                try {
                    const detalhes = typeof l.detalhes === 'string' ? JSON.parse(l.detalhes) : l.detalhes;
                    if (detalhes?.itens && Array.isArray(detalhes.itens)) {
                        detalhes.itens.forEach(item => {
                            const produtoNome = item.nome || item.item_nome || 'Produto Não Especificado';
                            const produtoValor = parseFloat(item.total || item.valor || item.valor_total || 0);

                            if (!produtoMap[produtoNome]) {
                                produtoMap[produtoNome] = {
                                    nome: produtoNome,
                                    total: 0,
                                    quantidade: 0,
                                    ocorrencias: 0
                                };
                            }

                            produtoMap[produtoNome].total += produtoValor;
                            produtoMap[produtoNome].quantidade += parseFloat(item.qtd || item.quantidade || 0);
                            produtoMap[produtoNome].ocorrencias++;
                        });
                    }
                } catch (e) {
                    // Ignore parsing errors
                }
            });

            // Sort products by total
            const produtos = Object.values(produtoMap).sort((a, b) => b.total - a.total);

            // Create modal
            const fmt = v => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
            const pct = (v, total) => total > 0 ? ((v / total) * 100).toFixed(1) + '%' : '0%';

            const modalHTML = `
                <div id="supplier-product-modal" style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); z-index: 10000; display: flex; align-items: center; justify-content: center;" onclick="document.getElementById('supplier-product-modal').remove()">
                    <div style="background: white; border-radius: 8px; padding: 20px; max-width: 800px; width: 90%; max-height: 90%; overflow: auto; box-shadow: 0 4px 6px rgba(0,0,0,0.1);" onclick="event.stopPropagation()">
                        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; border-bottom: 2px solid #e5e7eb; padding-bottom: 15px;">
                            <div>
                                <h3 style="margin: 0; color: #1e293b;">🏢 ${supplierName}</h3>
                                <p style="margin: 5px 0 0 0; color: #64748b; font-size: 0.9rem;">Produtos Comprados</p>
                            </div>
                            <button onclick="document.getElementById('supplier-product-modal').remove()" style="background: #ef4444; color: white; border: none; padding: 8px 16px; border-radius: 4px; cursor: pointer; font-weight: 600;">
                                <i class="fas fa-times"></i> Fechar
                            </button>
                        </div>
                        
                        ${produtos.length === 0 ? `
                            <div style="text-align: center; padding: 40px; color: #94a3b8;">
                                <i class="fas fa-box-open fa-3x"></i>
                                <p style="margin-top: 15px;">Nenhum produto detalhado encontrado nas notas deste fornecedor</p>
                                <p style="font-size: 0.85rem;">Total de ${supplierLancamentos.length} nota(s) sem detalhamento de itens</p>
                            </div>
                        ` : `
                            <table style="width: 100%; border-collapse: collapse; font-size: 0.9rem;">
                                <thead>
                                    <tr style="background: #f8fafc; border-bottom: 2px solid #e2e8f0;">
                                        <th style="padding: 10px; text-align: left;">#</th>
                                        <th style="padding: 10px; text-align: left;">Produto</th>
                                        <th style="padding: 10px; text-align: center;">Qtd</th>
                                        <th style="padding: 10px; text-align: center;">Compras</th>
                                        <th style="padding: 10px; text-align: right;">Total Gasto</th>
                                        <th style="padding: 10px; text-align: right;">% do Fornecedor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    ${produtos.map((p, idx) => `
                                        <tr style="border-bottom: 1px solid #f1f5f9;">
                                            <td style="padding: 10px; color: #64748b;">${idx + 1}</td>
                                            <td style="padding: 10px;"><strong>${p.nome}</strong></td>
                                            <td style="padding: 10px; text-align: center;">${p.quantidade.toFixed(2)}</td>
                                            <td style="padding: 10px; text-align: center;">${p.ocorrencias}x</td>
                                            <td style="padding: 10px; text-align: right; font-family: 'Courier New', monospace; font-weight: 600; color: #dc2626;">
                                                ${fmt(p.total)}
                                            </td>
                                            <td style="padding: 10px; text-align: right; color: #64748b;">${pct(p.total, totalSupplier)}</td>
                                        </tr>
                                    `).join('')}
                                </tbody>
                                <tfoot>
                                    <tr style="background: #f1f5f9; font-weight: 700; border-top: 2px solid #cbd5e1;">
                                        <td colspan="4" style="padding: 12px; text-align: right;">TOTAL:</td>
                                        <td style="padding: 12px; text-align: right; font-family: 'Courier New', monospace;">
                                            ${fmt(totalSupplier)}
                                        </td>
                                        <td style="padding: 12px; text-align: right;">100%</td>
                                    </tr>
                                </tfoot>
                            </table>
                        `}
                    </div>
                </div>
            `;

            document.body.insertAdjacentHTML('beforeend', modalHTML);

        } catch (e) {
            console.error('Erro Product Breakdown:', e);
            alert('Erro ao buscar produtos: ' + e.message);
        }
    },

    renderSafraView: async function (container) {
        container.innerHTML = `
            <style>
                .safra-container {
                    padding: 20px;
                    background: white;
                    height: 100%;
                    overflow: auto;
                }
                
                .safra-controls {
                    display: flex;
                    gap: 15px;
                    margin-bottom: 20px;
                    align-items: center;
                    padding-bottom: 15px;
                    border-bottom: 2px solid #e5e7eb;
                }
                
                .safra-content {
                    display: grid;
                    grid-template-columns: 1fr 500px;
                    gap: 20px;
                }
                
                .safra-table-container {
                    background: white;
                    border-radius: 8px;
                    overflow: auto;
                    max-height: 600px;
                }
                
                .safra-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 0.85rem;
                }
                
                .safra-table th {
                    background: #f8fafc;
                    padding: 10px;
                    text-align: left;
                    font-weight: 600;
                    color: #475569;
                    border-bottom: 2px solid #e2e8f0;
                    position: sticky;
                    top: 0;
                    z-index: 10;
                    font-size: 0.8rem;
                }
                
                .safra-table td {
                    padding: 10px;
                    border-bottom: 1px solid #f1f5f9;
                }
                
                .safra-table tr:hover {
                    background: #f8fafc;
                }
                
                .safra-chart-container {
                    background: white;
                    border-radius: 8px;
                    padding: 20px;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                }
            </style>
            
            <div class="safra-container">
                <div class="safra-controls">
                    <button onclick="window.FazendaRP.Pages.Relatorios.BIExplorer.generateSafraAnalysis()" class="btn btn-primary" style="padding: 8px 16px;">
                        <i class="fas fa-sync-alt"></i> Gerar Análise
                    </button>
                </div>
                
                <div class="safra-content">
                    <div class="safra-table-container">
                        <div id="safra-table-area" style="text-align:center; padding:60px; color:#94a3b8;">
                            <i class="fas fa-seedling fa-3x"></i>
                            <p style="margin-top:15px;">Clique em <b>"Gerar Análise"</b> para comparar safras</p>
                        </div>
                    </div>
                    
                    <div class="safra-chart-container">
                        <h4 style="margin: 0 0 15px 0; color: #1e293b;">Comparativo de Safras</h4>
                        <canvas id="safra-chart" width="450" height="400"></canvas>
                    </div>
                </div>
            </div>
        `;
    },

    generateSafraAnalysis: async function () {
        const tableArea = document.getElementById('safra-table-area');
        if (!tableArea) return;

        tableArea.innerHTML = '<div style="text-align:center; padding:40px;"><i class="fas fa-spinner fa-spin fa-2x"></i><p>Processando safras...</p></div>';

        try {
            // 1. Fetch all safras with area data
            const { data: safrasData } = await window.FazendaRP.supabase
                .from('safras_areas')
                .select('safra_id, area_ha')
                .order('safra_id', { ascending: false });

            if (!safrasData || safrasData.length === 0) {
                tableArea.innerHTML = '<div style="text-align:center; padding:40px; color:#94a3b8;"><i class="fas fa-exclamation-circle fa-2x"></i><p>Nenhuma safra cadastrada</p></div>';
                return;
            }

            // Aggregate area by safra_id
            const safraAreaMap = {};
            safrasData.forEach(s => {
                const sid = s.safra_id || 1;
                if (!safraAreaMap[sid]) safraAreaMap[sid] = 0;
                safraAreaMap[sid] += parseFloat(s.area_ha || 0);
            });

            // 2. Fetch all financial transactions with rateio
            const { data: lancamentos } = await window.FazendaRP.supabase
                .from('financeiro_lancamentos')
                .select('tipo, valor, detalhes')
                .neq('status', 'Cancelado');

            // 3. Process by safra
            const safraMetrics = {};

            lancamentos.forEach(l => {
                const detalhes = typeof l.detalhes === 'string' ? JSON.parse(l.detalhes) : (l.detalhes || {});
                const rateios = detalhes.rateio || [];
                const isReceita = l.tipo === 'Receita';

                // Process rateio array
                rateios.forEach(r => {
                    const sid = r.safra_id;
                    const valor = parseFloat(r.valor || 0);

                    if (sid && valor > 0) {
                        if (!safraMetrics[sid]) {
                            safraMetrics[sid] = { receita: 0, custo: 0 };
                        }

                        if (isReceita) {
                            safraMetrics[sid].receita += valor;
                        } else {
                            safraMetrics[sid].custo += Math.abs(valor);
                        }
                    }
                });

                // Also check per-item rateio (modo com_itens)
                const itens = detalhes.itens || [];
                itens.forEach(item => {
                    const itemRateios = item.rateio || [];
                    itemRateios.forEach(r => {
                        const sid = r.safra_id;
                        const valor = parseFloat(r.valor || 0);

                        if (sid && valor > 0) {
                            if (!safraMetrics[sid]) {
                                safraMetrics[sid] = { receita: 0, custo: 0 };
                            }

                            // Items are always costs (despesa)
                            safraMetrics[sid].custo += Math.abs(valor);
                        }
                    });
                });
            });

            // 4. Build safras list with metrics
            const safras = [];
            Object.keys(safraMetrics).forEach(sid => {
                const metrics = safraMetrics[sid];
                const area = safraAreaMap[sid] || 0;
                const receita = metrics.receita;
                const custo = metrics.custo;
                const margem = receita - custo;
                const margemPct = receita > 0 ? (margem / receita * 100) : 0;
                const receitaHa = area > 0 ? receita / area : 0;
                const custoHa = area > 0 ? custo / area : 0;

                safras.push({
                    id: parseInt(sid),
                    nome: `Safra ${sid}`,
                    area,
                    receita,
                    custo,
                    margem,
                    margemPct,
                    receitaHa,
                    custoHa
                });
            });

            // Sort by safra_id descending
            safras.sort((a, b) => b.id - a.id);

            if (safras.length === 0) {
                tableArea.innerHTML = '<div style="text-align:center; padding:40px; color:#94a3b8;"><i class="fas fa-info-circle fa-2x"></i><p>Nenhum lançamento com rateio por safra encontrado</p></div>';
                return;
            }

            // 5. Render table
            const fmt = v => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
            const fmtNum = v => v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

            let tableHTML = `
                <table class="safra-table">
                    <thead>
                        <tr>
                            <th>Safra</th>
                            <th style="text-align: right;">Área (ha)</th>
                            <th style="text-align: right;">Receita</th>
                            <th style="text-align: right;">Custos</th>
                            <th style="text-align: right;">Margem</th>
                            <th style="text-align: right;">Margem %</th>
                            <th style="text-align: right;">Receita/ha</th>
                            <th style="text-align: right;">Custo/ha</th>
                        </tr>
                    </thead>
                    <tbody>
            `;

            safras.forEach(s => {
                const margemColor = s.margem >= 0 ? '#166534' : '#dc2626';

                tableHTML += `
                    <tr>
                        <td><strong>${s.nome}</strong></td>
                        <td style="text-align: right;">${fmtNum(s.area)} ha</td>
                        <td style="text-align: right; color: #166534; font-family: 'Courier New', monospace;">${fmt(s.receita)}</td>
                        <td style="text-align: right; color: #dc2626; font-family: 'Courier New', monospace;">${fmt(s.custo)}</td>
                        <td style="text-align: right; color: ${margemColor}; font-weight: 600; font-family: 'Courier New', monospace;">${fmt(s.margem)}</td>
                        <td style="text-align: right; color: ${margemColor};">${s.margemPct.toFixed(1)}%</td>
                        <td style="text-align: right; font-family: 'Courier New', monospace; font-size: 0.8rem;">${fmt(s.receitaHa)}</td>
                        <td style="text-align: right; font-family: 'Courier New', monospace; font-size: 0.8rem;">${fmt(s.custoHa)}</td>
                    </tr>
                `;
            });

            tableHTML += '</tbody></table>';
            tableArea.innerHTML = tableHTML;

            // 6. Render chart
            this.renderSafraChart(safras);

        } catch (e) {
            console.error('Erro Safra Analysis:', e);
            tableArea.innerHTML = `<div style="color:red; padding:20px;">Erro: ${e.message}</div>`;
        }
    },

    renderSafraChart: function (safras) {
        const canvas = document.getElementById('safra-chart');
        if (!canvas) return;

        // Destroy previous chart if exists
        if (this.safraChart) {
            this.safraChart.destroy();
        }

        const ctx = canvas.getContext('2d');

        // Prepare data (reverse to show oldest at bottom)
        const labels = safras.map(s => s.nome).reverse();
        const receitaData = safras.map(s => s.receita).reverse();
        const custoData = safras.map(s => s.custo).reverse();
        const margemData = safras.map(s => s.margem).reverse();

        this.safraChart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: labels,
                datasets: [
                    {
                        label: 'Receita',
                        data: receitaData,
                        backgroundColor: '#10b981',
                        borderColor: '#059669',
                        borderWidth: 1
                    },
                    {
                        label: 'Custos',
                        data: custoData,
                        backgroundColor: '#ef4444',
                        borderColor: '#dc2626',
                        borderWidth: 1
                    },
                    {
                        label: 'Margem',
                        data: margemData,
                        backgroundColor: '#3b82f6',
                        borderColor: '#2563eb',
                        borderWidth: 1
                    }
                ]
            },
            options: {
                indexAxis: 'y', // Horizontal bars
                responsive: true,
                maintainAspectRatio: true,
                plugins: {
                    legend: {
                        position: 'top',
                        labels: {
                            boxWidth: 15,
                            padding: 10,
                            font: { size: 11 }
                        }
                    },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                const label = context.dataset.label || '';
                                const value = context.parsed.x;
                                return `${label}: ${value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
                            }
                        }
                    }
                },
                scales: {
                    x: {
                        beginAtZero: true,
                        ticks: {
                            callback: function (value) {
                                return 'R$ ' + (value / 1000).toFixed(0) + 'k';
                            }
                        }
                    }
                }
            }
        });
    },

    initDragDrop: function () {
        const fieldList = document.getElementById('bi-field-list');

        // Render fields
        this.availableFields.forEach(field => {
            const div = document.createElement('div');
            div.className = 'bi-field-item';
            div.draggable = true;
            div.dataset.fieldId = field.id;
            div.innerHTML = `<i class="fas fa-grip-vertical" style="opacity: 0.3; margin-right: 8px;"></i> ${field.label}`;

            div.addEventListener('dragstart', (e) => {
                e.dataTransfer.setData('fieldId', field.id);
                e.dataTransfer.setData('fieldLabel', field.label);
                div.classList.add('dragging');
            });

            div.addEventListener('dragend', () => {
                div.classList.remove('dragging');
            });

            fieldList.appendChild(div);
        });

        // Setup drop zones
        ['bi-drop-rows', 'bi-drop-cols'].forEach(zoneId => {
            const zone = document.getElementById(zoneId);

            zone.addEventListener('dragover', (e) => {
                e.preventDefault();
                zone.classList.add('drag-over');
            });

            zone.addEventListener('dragleave', () => {
                zone.classList.remove('drag-over');
            });

            zone.addEventListener('drop', (e) => {
                e.preventDefault();
                zone.classList.remove('drag-over');

                const fieldId = e.dataTransfer.getData('fieldId');
                const fieldLabel = e.dataTransfer.getData('fieldLabel');
                const zoneType = zone.dataset.zone;

                this.addFieldToZone(fieldId, fieldLabel, zoneType);
            });
        });
    },

    addFieldToZone: function (fieldId, fieldLabel, zoneType) {
        const zone = document.getElementById(zoneType === 'rows' ? 'bi-drop-rows' : 'bi-drop-cols');

        // Check if already exists
        if (zone.querySelector(`[data-field-id="${fieldId}"]`)) return;

        // Remove placeholder
        const placeholder = zone.querySelector('span');
        if (placeholder) placeholder.remove();

        // Create chip
        const chip = document.createElement('div');
        chip.className = 'bi-field-chip';
        chip.dataset.fieldId = fieldId;
        chip.innerHTML = `
            ${fieldLabel}
            <span class="remove">×</span>
        `;

        chip.querySelector('.remove').addEventListener('click', () => {
            chip.remove();

            // Update state
            if (zoneType === 'rows') {
                this.state.rowFields = this.state.rowFields.filter(f => f !== fieldId);
            } else {
                this.state.colFields = this.state.colFields.filter(f => f !== fieldId);
            }

            // Re-add placeholder if empty
            const zoneEl = document.getElementById(zoneType === 'rows' ? 'bi-drop-rows' : 'bi-drop-cols');
            if (zoneEl.children.length === 0) {
                zoneEl.innerHTML = '<span style="color: #94a3b8; font-size: 0.85rem;">Nenhum campo selecionado</span>';
            }
        });

        zone.appendChild(chip);

        // Update state
        if (zoneType === 'rows') {
            this.state.rowFields.push(fieldId);
        } else {
            this.state.colFields.push(fieldId);
        }
    },

    initEvents: function () {
        document.getElementById('bi-refresh-btn').addEventListener('click', () => {
            this.generatePivot();
        });

        document.getElementById('bi-agg-select').addEventListener('change', (e) => {
            this.state.aggregation = e.target.value;
        });
    },

    applyTemplate: function (templateName) {
        // Clear existing selections
        this.clearAllFields();

        // Apply template
        if (templateName === 'dre') {
            this.addFieldToZone('categoria', 'Categoria', 'rows');
            this.addFieldToZone('mes', 'Mês', 'cols');
        } else if (templateName === 'fornecedores') {
            this.addFieldToZone('parceiro', 'Parceiro', 'rows');
        } else if (templateName === 'safra') {
            this.addFieldToZone('categoria', 'Categoria', 'rows');
            this.addFieldToZone('safra', 'Safra', 'cols');
        }

        // Auto-generate
        setTimeout(() => {
            this.generatePivot();
        }, 300);
    },

    clearAllFields: function () {
        // Clear rows
        const rowZone = document.getElementById('bi-drop-rows');
        rowZone.innerHTML = '<span style="color: #94a3b8; font-size: 0.85rem;">Nenhum campo selecionado</span>';
        this.state.rowFields = [];

        // Clear columns
        const colZone = document.getElementById('bi-drop-cols');
        colZone.innerHTML = '<span style="color: #94a3b8; font-size: 0.85rem;">Nenhum campo selecionado</span>';
        this.state.colFields = [];
    },

    loadData: async function () {
        try {
            const currentYear = new Date().getFullYear();

            // Fetch last 2 years of data
            const { data: lancamentos, error } = await window.FazendaRP.supabase
                .from('financeiro_lancamentos')
                .select('*, parceiros(nome), financeiro_contas(nome)')
                .gte('data_emissao', `${currentYear - 1}-01-01`)
                .neq('status', 'Cancelado');

            if (error) throw error;

            // Transform data
            this.state.data = lancamentos.map(l => {
                const detalhes = typeof l.detalhes === 'string' ? JSON.parse(l.detalhes || '{}') : l.detalhes || {};
                const dataEmissao = new Date(l.data_emissao);

                return {
                    id: l.id,
                    valor: parseFloat(l.valor || 0),
                    tipo: l.tipo,
                    categoria: l.categoria || 'Sem Categoria',
                    parceiro: l.parceiros?.nome || 'Sem Parceiro',
                    conta: l.financeiro_contas?.nome || 'Sem Conta',
                    status: l.status,
                    mes: dataEmissao.toLocaleString('pt-BR', { month: 'short' }),
                    ano: dataEmissao.getFullYear().toString(),
                    safra: detalhes.safra_nome || 'Sem Safra',
                    descricao: l.descricao || ''
                };
            });

            console.log(`BI Explorer: ${this.state.data.length} registros carregados`);

        } catch (e) {
            console.error('Erro ao carregar dados BI:', e);
            alert('Erro ao carregar dados: ' + e.message);
        }
    },

    generatePivot: function () {
        if (!this.state.data || this.state.data.length === 0) {
            alert('Nenhum dado disponível. Aguarde o carregamento.');
            return;
        }

        if (this.state.rowFields.length === 0 && this.state.colFields.length === 0) {
            alert('Selecione pelo menos um campo para Linhas ou Colunas.');
            return;
        }

        const resultArea = document.getElementById('bi-result-area');
        resultArea.innerHTML = '<div style="text-align:center; padding:40px;"><i class="fas fa-spinner fa-spin fa-2x"></i><p>Gerando análise...</p></div>';

        setTimeout(() => {
            this.renderPivotTable();
        }, 100);
    },

    renderPivotTable: function () {
        const { rowFields, colFields, data, aggregation } = this.state;

        // Simple case: Only rows (no columns)
        if (rowFields.length > 0 && colFields.length === 0) {
            this.renderSimpleTable(rowFields, data, aggregation);
            return;
        }

        // Full pivot with rows AND columns
        if (rowFields.length > 0 && colFields.length > 0) {
            this.renderCrossTable(rowFields, colFields, data, aggregation);
            return;
        }

        // Only columns (rare case)
        if (colFields.length > 0 && rowFields.length === 0) {
            this.renderSimpleTable(colFields, data, aggregation);
        }
    },

    renderSimpleTable: function (fields, data, aggregation) {
        // Group by fields
        const grouped = {};

        data.forEach(row => {
            const key = fields.map(f => row[f] || 'N/A').join('|');

            if (!grouped[key]) {
                grouped[key] = {
                    labels: fields.map(f => row[f] || 'N/A'),
                    values: []
                };
            }

            grouped[key].values.push(row.valor);
        });

        // Calculate aggregations
        const results = Object.entries(grouped).map(([key, group]) => {
            let aggValue = 0;

            if (aggregation === 'sum') {
                aggValue = group.values.reduce((a, b) => a + b, 0);
            } else if (aggregation === 'count') {
                aggValue = group.values.length;
            } else if (aggregation === 'avg') {
                aggValue = group.values.reduce((a, b) => a + b, 0) / group.values.length;
            }

            return {
                labels: group.labels,
                value: aggValue
            };
        });

        // Sort by value desc
        results.sort((a, b) => b.value - a.value);

        // Render
        const resultArea = document.getElementById('bi-result-area');

        let html = `
            <table class="bi-result-table">
                <thead>
                    <tr>
                        ${fields.map(f => `<th>${this.getFieldLabel(f)}</th>`).join('')}
                        <th style="text-align: right;">Valor</th>
                    </tr>
                </thead>
                <tbody>
        `;

        results.forEach(r => {
            html += `
                <tr>
                    ${r.labels.map(l => `<td>${l}</td>`).join('')}
                    <td class="value-cell">${this.formatValue(r.value, aggregation)}</td>
                </tr>
            `;
        });

        html += `
                </tbody>
            </table>
        `;

        resultArea.innerHTML = html;
    },

    renderCrossTable: function (rowFields, colFields, data, aggregation) {
        const resultArea = document.getElementById('bi-result-area');

        // Simplified cross-table (1 row field x 1 col field)
        if (rowFields.length === 1 && colFields.length === 1) {
            const rowField = rowFields[0];
            const colField = colFields[0];

            // Get unique values
            const rowValues = [...new Set(data.map(d => d[rowField] || 'N/A'))].sort();
            const colValues = [...new Set(data.map(d => d[colField] || 'N/A'))].sort();

            // Build matrix
            const matrix = {};
            data.forEach(row => {
                const rKey = row[rowField] || 'N/A';
                const cKey = row[colField] || 'N/A';

                if (!matrix[rKey]) matrix[rKey] = {};
                if (!matrix[rKey][cKey]) matrix[rKey][cKey] = [];

                matrix[rKey][cKey].push(row.valor);
            });

            // Render
            let html = `
                <table class="bi-result-table">
                    <thead>
                        <tr>
                            <th>${this.getFieldLabel(rowField)}</th>
                            ${colValues.map(c => `<th style="text-align: right;">${c}</th>`).join('')}
                            <th style="text-align: right;">TOTAL</th>
                        </tr>
                    </thead>
                    <tbody>
            `;

            rowValues.forEach(r => {
                let rowTotal = 0;
                html += `<tr><td><b>${r}</b></td>`;

                colValues.forEach(c => {
                    const values = matrix[r]?.[c] || [];
                    let cellValue = 0;

                    if (aggregation === 'sum') {
                        cellValue = values.reduce((a, b) => a + b, 0);
                    } else if (aggregation === 'count') {
                        cellValue = values.length;
                    } else if (aggregation === 'avg') {
                        cellValue = values.length > 0 ? values.reduce((a, b) => a + b, 0) / values.length : 0;
                    }

                    rowTotal += cellValue;
                    html += `<td class="value-cell">${this.formatValue(cellValue, aggregation)}</td>`;
                });

                html += `<td class="value-cell" style="background: #f8fafc; font-weight: 700;">${this.formatValue(rowTotal, aggregation)}</td>`;
                html += `</tr>`;
            });

            html += `</tbody></table>`;
            resultArea.innerHTML = html;
        }
    },

    getFieldLabel: function (fieldId) {
        const field = this.availableFields.find(f => f.id === fieldId);
        return field ? field.label : fieldId;
    },

    formatValue: function (value, aggregation) {
        if (aggregation === 'count') {
            return value.toLocaleString('pt-BR');
        }
        return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
};